import React from "react";
import { Box, Button, Modal } from "@mui/material";

import './viewSchedulesModal.css';
import { exportToExcel } from "../utils/exportExcel";
import { calculateDifferences } from "../utils/generalFunctions";

const ViewSchedulesModal = ({ open, onClose, schedules = [], prev = false, scheduleRegister, onlyView = false }) => {
  const formatTime = (time) => {
    if (time === null || time === undefined) return ""; // Mostrar cadena vacía si el tiempo es null
    const hours = Math.floor(time / 3600).toString().padStart(2, '0');
    const minutes = Math.floor((time % 3600) / 60).toString().padStart(2, '0');
    const seconds = (time % 60).toString().padStart(2, '0');

    return `${hours}:${minutes}:${seconds}`;
  };

  const importSchedules = () => {
    scheduleRegister(schedules);
    onClose();
  }

  return (
    <Modal open={open} onClose={onClose}>
      <Box className="modal_box schedules_modal">
        <h1>{prev ? 'Previsualización de los horarios' : 'Detalles de los Horarios'}</h1>
        <div style={{ display: "flex", flexDirection: 'column', justifyContent: 'space-between', flex: 1, overflowY: 'auto', gap: '2rem' }}>
          <div className="view_schedules_container">
            {schedules.map((schedule, index) => (
              <div key={index}>
                <h2>{schedule.name}</h2>
                <div className="table_wrapper">
                  <table>
                    <thead>
                      {/* Primera fila: Nombre del horario */}
                      {/* <tr>
                        <th colSpan={schedule.turns[0]?.length || 1}>{schedule.name}</th>
                      </tr> */}
                      {/* Segunda fila: Nombres de los puntos de control */}
                      <tr>
                        {schedule.turns[0]?.map((point, pointIndex) => (
                          <th key={pointIndex}>{point.label}</th>
                        ))}
                      </tr>
                      {/* Tercera fila: Minutos de diferencia entre puntos de control */}
                      <tr>
                        {calculateDifferences(
                          schedule.turns[0],
                          schedule.turns,
                          0
                        ).map((difference, diffIndex) => (
                          <th key={diffIndex}>{difference.minutes.toString().padStart(2, '0')}:{difference.seconds.toString().padStart(2, '0')}</th>
                        ))}
                      </tr>
                    </thead>
                    <tbody>
                      {/* Filas del cuerpo: Valores de las horas por vuelta */}
                      {schedule.turns.map((lap, lapIndex) => (
                        <tr key={lapIndex}>
                          {lap.map((point, pointIndex) => (
                            <td key={pointIndex}>{formatTime(point.time)}</td>
                          ))}
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            ))}
          </div>
          <Box className="button_container" sx={{ marginTop: 0 }}>
            <span style={{ margin: 'auto auto auto 0', fontSize: '1rem', padding: '0 1.5rem', color: 'var(--color-primary)' }}>Horarios: {schedules.length}</span>
            <Button onClick={onClose} color="error">Cancelar</Button>
            {prev && !onlyView ?
              <Button onClick={() => importSchedules()} variant="contained" color="primary">
                Importar horarios
              </Button>
              :
              <Button onClick={() => exportToExcel(schedules)} variant="contained" color="primary">
                Exportar a Excel
              </Button>
            }
          </Box>
        </div>
      </Box>
    </Modal>
  );
};

export default ViewSchedulesModal;
